import { Toast } from 'mint-ui'

const ALERT_DURATION = 3000

export const Alert = {
  /**
     * 成功
     * @param {string} message
     * @param {number} duration
     */
  success (message, duration = ALERT_DURATION) {
    Toast({ message, duration, iconClass: 'mint-toast-icon-success iconfont icon-zhengque' })
  },
  /**
     * 提示
     * @param {string} message
     * @param {number} duration
     */
  notice (message, duration = ALERT_DURATION) {
    Toast({ message, duration, iconClass: 'mint-toast-icon-notice iconfont icon-tishi' })
  },
  /**
     * 提醒
     * @param {string} message
     * @param {number} duration
     */
  remain (message, duration = ALERT_DURATION) {
    Toast({ message, duration, iconClass: 'mint-toast-icon-remain iconfont icon-tixing' })
  },
  /**
     * 警告
     * @param {string} message
     * @param {number} duration
     */
  warning (message, duration = ALERT_DURATION) {
    Toast({ message, duration, iconClass: 'mint-toast-icon-warning iconfont icon-jingshi' })
  },
  /**
     * 錯誤
     * @param {string} message
     * @param {number} duration
     */
  error (message, duration = ALERT_DURATION) {
    Toast({ message, duration, iconClass: 'mint-toast-icon-error iconfont icon-chucuo' })
  }
}
